import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiReportService } from '@providers/api/report/report.service';
import { UserProfile } from '@providers/api/user/user.data.interface';
import {
  BaseResponseBody,
  GETBaseResponseBody,
  GetUserProfileDetailsQueryParams
} from '@providers/api/user/user.request.interface';
import { UserAPIService } from '@providers/api/user/user.service';
import { QuestionnaireNourishSubmitPayload } from './nourish.interface';

/**
 * NourishService is a service that provides functionality related to the Nourish questionnaire.
 *
 * @exports
 * @class NourishService
 */
@Injectable()
export class QuestionnaireNourishService extends ApiReportService {
  private readonly userService = inject(UserAPIService);

  /**
   * Fetch user profile.
   *
   * @returns {Observable<GETBaseResponseBody<Array<UserProfile>>>}
   * @memberof QuestionnaireNourishService
   */
  fetchUserProfile(): Observable<GETBaseResponseBody<Array<UserProfile>>> {
    const params: GetUserProfileDetailsQueryParams = {
      limit: 1,
      withCount: false,
      include: [
        'allergy',
        'information',
        'medical',
        'medication',
        'historical-last-state-update',
        'user-lifestyle'
      ]
    };
    return this.userService.get<GETBaseResponseBody<Array<UserProfile>>>(
      'user-profiles',
      params
    );
  }

  /**
   * Submit questionnaire.
   *
   * @param {QuestionnaireNourishSubmitPayload} body Payload.
   * @returns {Observable<BaseResponseBody<unknown>>}
   * @memberof QuestionnaireNourishService
   */
  submit(
    body: QuestionnaireNourishSubmitPayload
  ): Observable<BaseResponseBody<unknown>> {
    const endpoint = 'questionnaire/submit';
    return this.post<BaseResponseBody<unknown>>(endpoint, body);
  }
}
